import React from 'react';

import { AppointmentRegistrationModal as AppointmentRegistrationModalView } from './appointment-registration-modal';
import { AppointmentRegistrationModalContainerProps } from './appointment-registration-modal.models';

export const AppointmentRegistrationModal = ({
  updateAppointments,
  onRegistrationComplete,
  goNextButtonTestIdsByStep,
  goNextButtonTestId,
  ...props
}: AppointmentRegistrationModalContainerProps,
): JSX.Element => {
  const handleRegistrationDone = (): void => {
    onRegistrationComplete();
  };

  return (
    <AppointmentRegistrationModalView
      {...props}
      updateAppointments={updateAppointments}
      onDone={handleRegistrationDone}
      goNextButtonTestIdsByStep={goNextButtonTestIdsByStep}
      goNextButtonTestId={goNextButtonTestId}
    />
  );
};
